import { billOfMaterialsLocationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deleteBillOfMaterialsLocation = {
  name: "deleteBillOfMaterialsLocation" as const,
  input: z.object({
    billOfMaterialsLocationId: billOfMaterialsLocationIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};
